import OperatorRow from '../OperatorRow/OperatorRow'
import { OperatorRowData } from '../useOperatorsTable'
import { Td } from '../styled-components'

const COLUMN_COUNT = 4

interface OperatorsTableBodyProps {
  rows: OperatorRowData[]
  isSubmitting: boolean
  emptyText: string
  forceStopLabel: string
}

const OperatorsTableBody = ({ rows, isSubmitting, emptyText, forceStopLabel }: OperatorsTableBodyProps) => {
  if (rows.length === 0) {
    return (
      <tr>
        <Td colSpan={COLUMN_COUNT}>{emptyText}</Td>
      </tr>
    )
  }

  return (
    <>
      {rows.map(row => (
        <OperatorRow key={row.breakId} row={row} isSubmitting={isSubmitting} forceStopLabel={forceStopLabel} />
      ))}
    </>
  )
}

export default OperatorsTableBody
